import type { RunSummary } from "./types.js";

export type HumanWorkUrgency = "overdue" | "due_soon";

type DueRun = Pick<RunSummary, "doNotContact" | "handoffOwner" | "nextAction" | "nextActionAt" | "stage">;

export function humanWorkUrgency(run: DueRun, nowMs = Date.now()): HumanWorkUrgency | null {
  if (!run.handoffOwner || !run.nextAction || !run.nextActionAt || run.doNotContact || run.stage === "do_not_contact" || run.stage === "closed_not_fit" || run.stage === "closed") return null;
  const dueMs = new Date(run.nextActionAt).getTime();
  if (!Number.isFinite(dueMs)) return null;
  if (dueMs <= nowMs) return "overdue";
  if (dueMs <= nowMs + 24 * 60 * 60 * 1000) return "due_soon";
  return null;
}
